let cachedQdsBlob: Blob | null = null;

export const QdsBlobCache = {
  set(blob: Blob) {
    cachedQdsBlob = blob;
  },
  get(): Blob | null {
    return cachedQdsBlob;
  },
  clear() {
    cachedQdsBlob = null;
  },
};
